import { useRegionContext } from 'context/RegionContext';
import { useContext, useEffect, useState } from 'react';
import { Header, HeaderContent } from '../MapRenderer.styled';
import { getRegionDisplayName } from 'pages/Map/regionHelper';
import { Text } from '@medly-components/core';
import MapSearchIcon from 'pages/MapSearch/MapSearchIcon';
import { MapSearchContext } from 'context/MapSearchContext';
import { useTheme } from 'styled-components';
import { useIsMobile } from 'hooks';
import { ZoneContext } from 'context/ZoneContext';
import { Direction } from 'types';

export const MapHeader = () => {
    const { region, readonly } = useRegionContext();
    const { mapState } = useContext(ZoneContext);
    const { isMapSearch } = useContext(MapSearchContext);
    const { colors } = useTheme();

    const [showHeader, setShowHeader] = useState(true);
    const isMobile = useIsMobile();

    useEffect(() => {
        setShowHeader(true);
    }, [isMobile]);

    useEffect(() => {
        if (!isMobile) {
            return;
        }
        if (mapState.current.scrollDirection === Direction.UP) {
            setShowHeader(false);
        } else if (mapState.current.scrollDirection === Direction.DOWN) {
            setShowHeader(true);
        }
    }, [mapState.current.scrollDirection]);

    if (!showHeader) {
        return null;
    }

    return (
        <Header>
            <Header.BackButton></Header.BackButton>
            <HeaderContent px={0} py={0} color={colors.darkBlue}>
                <Text textVariant="h3" textAlign="center">
                    {getRegionDisplayName(region)}
                </Text>
            </HeaderContent>
            {!isMapSearch && !readonly && !isMobile ? <MapSearchIcon /> : null}
        </Header>
    );
};
